// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_61-6";
export var headerCell = "_61-2";
export var rowWrapper = "_61-4";
export var stickyAggregationCell = "_61-a";
export var stickyAggregationRow = "_61-7";
export var stickyColumnCell = "_61-9";
export var stickyColumnHeaderCell = "_61-8";
export var table = "_61-1";
export var virtualRowWrapper = "_61-5";
export var virtualTableContainer = "_61-0";
export var white = "_61-3";